import { render, staticRenderFns } from "./features24.vue?vue&type=template&id=3bf3c46e&scoped=true"
import script from "./features24.vue?vue&type=script&lang=js"
export * from "./features24.vue?vue&type=script&lang=js"
import style0 from "./features24.vue?vue&type=style&index=0&id=3bf3c46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf3c46e",
  null
  
)

export default component.exports